module.exports = __webpack_public_path__ + "img/document.3c5dc73f.png";